import { FETCH_DATA_FAILURE, LOGIN_FAILURE, LOGOUT } from 'features/user/userTypes';
import { clearFiltersFromStorage, saveFiltersToStorage } from './globalFiltersStorage';
import { RESET_FILTERS, SET_FILTERS } from './globalFiltersReducer';

const CLEAR_STORAGE_ACTIONS = [LOGIN_FAILURE, FETCH_DATA_FAILURE, LOGOUT];

const globalFiltersMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  if (action.type === SET_FILTERS) {
    saveFiltersToStorage(store.getState().globalFilters.applied);
  } else if (action.type === RESET_FILTERS) {
    clearFiltersFromStorage();
  } else if (CLEAR_STORAGE_ACTIONS.includes(action.type)) {
    clearFiltersFromStorage();
  }

  return result;
};

export default globalFiltersMiddleware;
